module.exports = __webpack_public_path__ + "static/media/education.c233c834.png";